import React from "react";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import axios from "axios";
import { Container, Row, Col } from "shards-react";
import CircularProgress from "@material-ui/core/CircularProgress";
import CustomToolbar from "../common/AddButton";

import Button from "@material-ui/core/Button";
//import { Store } from "../../flux";
import api from "../common/api";
import { TextField } from "@material-ui/core";

class ProviderVouchers extends React.Component {
  constructor() {
    super();

    this.state = {
      data: "",
      isLoaded: false,
      vouchers: []
    };
  }

  async componentDidMount() {
    await this.getVouchers();
  }

  getVouchers() {
    const token = localStorage.getItem("userToken");

    return axios
      .get(api.vouchers().index(8), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        this.setState({ isLoaded: true, vouchers: res.data });
      })
      .catch(err => {
        this.setState({ isLoaded: true, vouchers: [] });
      });
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
          root: {
            padding: "0px 8px 0px 8px",
            fontSize: "0.73rem"
          }
        }
      }
    });

  render() {
    const columns = [
      {
        name: "id",
        label: "Id",
        options: {
          filter: false,
          display: false,
          sort: true
        }
      },
      {
        name: "hansa_code",
        label: "# Factura Hansa",
        options: {
          filter: false,
          display: true,
          sort: true
        }
      },
      {
        name: "contact.business_name",
        label: "Proveedor",
        options: {
          filter: true,
          filterType: "select",
          sort: true
        }
      },
      {
        name: "contract",
        label: "Cliente",
        options: {
          filter: true,
          filterType: "select",
          sort: true
        }
      },
      {
        name: "work_order.id",
        label: "OT",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                <a href={"work-order/" + value} target="_blank">
                  {value}
                </a>
              </div>
            );
          }
        }
      },
      {
        name: "work_order.plate",
        label: "Patente",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "work_order.state",
        label: "Estado OT",
        options: {
          filter: true,
          display: false,
          filterType: "select",
          sort: true
        }
      },
      {
        name: "number",
        label: "Numero",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "state",
        label: "Estado",
        options: {
          filter: true,
          filterType: "select",
          filterList: ["PENDIENTE VALIDACION"],
          sort: true
        }
      },
      {
        name: "total_s_iva_price",
        label: "Total factura OT",
        options: {
          filter: true,
          filterType: "select",
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                {value
                  .toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD"
                  })
                  .replace(/\./g, "|")
                  .replace(/,/g, ".")
                  .replace(/\|/g, ",")}
              </div>
            );
          }
        }
      },
      {
        name: "voucher_total_s_iva_price",
        label: "Total factura",
        options: {
          filter: true,
          /*filterType: "textField",
          sort: true,
          filterList: [500000],
          filterOptions: {
            logic(total, filterVal) {
              const show = parseInt(total) >= parseInt(filterVal);
              return !show;
            }
          },
          */
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <div>
                {value
                  .toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD"
                  })
                  .replace(/\./g, "|")
                  .replace(/,/g, ".")
                  .replace(/\|/g, ",")}
              </div>
            );
          }
        }
      },
      {
        name: "reception_date",
        label: "Recepcion",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "payment_date",
        label: "Pago",
        options: {
          filter: true,
          filterType: "textField",
          sort: true
        }
      },
      {
        name: "due_date",
        label: "Vencimiento",
        options: {
          filter: true,
          filterType: "textField",
          sort: true,
          customBodyRender: (value, tableMeta, updateValue) => {
            var days_to_due_date = tableMeta.rowData[11];
            value = value ? value : "Sin fecha cargada";
            if (days_to_due_date !== "") {
              if (days_to_due_date < 10) {
                if (days_to_due_date < 5) {
                  if (days_to_due_date === 0) {
                    return (
                      <div class="text-danger font-weight-bold">
                        <i class="material-icons">warning</i>
                        {value}
                      </div>
                    );
                  } else {
                    return (
                      <div class="text-warning font-weight-bold">
                        <i class="material-icons">warning</i>
                        {value}
                      </div>
                    );
                  }
                } else {
                  return (
                    <div class="text-info font-weight-bold">
                      <i class="material-icons">warning</i>
                      {value}
                    </div>
                  );
                }
              }
            }
            return <div>{value}</div>;
          }
        }
      },
      {
        name: "days_to_due_date",
        label: "Días para el Vencimiento",
        options: {
          filter: true,
          filterType: "textField",
          display: false
        }
      }
    ];

    const options = {
      print: false,
      responsive: "stacked",
      selectableRowsOnClick: false,
      selectedRows: false,
      selectableRows: false,
      download: false,
      rowsPerPage: 100,
      customToolbar: () => {
        return <CustomToolbar url="new" />;
      },
      textLabels: {
        toolbar: {
          search: "Buscar",
          viewColumns: "Ver columnas",
          filterTable: "Filtros",
          downloadCsv: "Exportar XLS"
        },
        body: {
          noMatch: this.state.isLoaded ? (
            "No hay resultados"
          ) : (
            <CircularProgress />
          )
        },
        selectedRows: {
          text: "fila(s) seleccionadas"
        },
        viewColumns: {
          title: "Ver columnas"
        },
        pagination: {
          next: "Siguiente",
          previous: "Anteior",
          rowsPerPage: "Cantidad por página:",
          displayRows: "de"
        },
        filter: {
          all: "Todos",
          title: "Filtros",
          reset: "Limpiar"
        }
      }
    };

    return (
      <Container fluid className="main-content-container px-4">
        <Row>
          <Col className="p-2">
            <div>
              <MuiThemeProvider theme={this.getMuiTheme()}>
                <MUIDataTable
                  title="Lista de Comprobantes"
                  data={Object.values(this.state.vouchers)}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ProviderVouchers;
